import { Input } from "@ember/component";
import { on } from "@ember/modifier";
import { isEmpty } from "@ember/utils";
import discourseDebounce from "discourse/lib/debounce";
import { bind } from "discourse/lib/decorators";
import { INPUT_DELAY } from "discourse/lib/environment";
import SearchFieldBase from "./base";
import SearchFieldWireFrame from "./wire-frame";

export default class SearchFieldText extends SearchFieldBase {
  @bind
  onValueChanged(event) {
    discourseDebounce(
      this,
      this.#debouncedValue,
      event.target.value,
      INPUT_DELAY
    );
  }

  #debouncedValue(value) {
    this.args.controller.set(
      this.args.filter.queryParameter,
      isEmpty(value) ? null : value
    );
  }

  <template>
    <SearchFieldWireFrame
      ...attributes
      @controller={{@controller}}
      @filter={{@filter}}
      @value={{@value}}
    >
      <Input
        placeholder={{this.placeholder}}
        class="no-blur"
        @value={{readonly @value}}
        {{on "input" this.onValueChanged}}
      />
    </SearchFieldWireFrame>
  </template>
}
